import { smartChat, assignation, botConsole, categories, /* apiPools, */ foldersAPI } from 'api'

const processesOptions = async ({ headerId, currentProcess }) => {
  const processes = []

  if (!headerId) return processes

  const { data } = await smartChat.getProcessesPartialList(headerId)
  data.forEach(process => {
    if (process.processType === 'customer_alternative_branch') return
    if (currentProcess && process._id === currentProcess) return

    processes.push({ value: process.processId, label: process.processName })
  })

  return processes
}

const randomResponsesOptions = async () => {
  const messagesGroups  = []

  const { data } = await smartChat.getGroupsList()
  data.forEach(group => messagesGroups.push({ value: group._id, label: group.name }))

  return messagesGroups
}

const operatorsOptions = async ({ delegations = null, brands = null }) => {
  const operators = []
  const params = { size: 1000 }
  if (delegations) params.delegations = delegations
  if (brands) params.brands = brands
  const { data } = await assignation.getAvailableOperators(params)
  data.operators.forEach(operator => operators.push({ value: operator._id, label: `${operator.name} ${operator.lastname}` }))

  return operators
}

const vaOptions = async () => {
  const virtualAssistants  = []

  const { data } = await botConsole.getVaList()
  data.result.forEach(va => virtualAssistants.push({ value: va.consoleId, label: va.name ? va.name : 'Global' }))

  return virtualAssistants
}

const vaCategoriesOptions = async ({ consoleId }) => {
  const vaCategories  = []

  const { data } = await botConsole.getBotHeader(consoleId)
  data.faqViewControl.forEach(({ id, category }) => vaCategories.push({
    value: id,
    label: category === 'none' ? 'General' : category
  }))

  return vaCategories
}

const vaFaqsOptions = async ({ consoleId, categoryName }) => {
  const vaFaqs  = []

  const { data } = await botConsole.getIntents(consoleId)
  data.results.filter(intent => intent.category === (categoryName === 'General' ? 'none' : categoryName))
    .forEach(intent => vaFaqs.push({
      value: intent.id,
      label: intent.faqTitle
    }))

  return vaFaqs
}

const categoriesOptions = async () => {
  const categoriesList = []

  const { data } = await categories.get()
  data.forEach(category => categoriesList.push({ value: category._id, label: category.name }))

  return categoriesList
}

// const managementListsOptions = async () => {
//   const managementLists = []

//   const { data } = await apiPools.listsUsers({ action: 'listsAndUsers', withPendingMsg: false, notAssigned: false })
//   data.lists.forEach(managementList => managementLists.push({ value: managementList._id, label: managementList.name }))

//   return managementLists
// }

const foldersOptions = async () => {
  const foldersList = []

  const { data } = await foldersAPI.getFolders({ fields: ['name', 'listId'] })
  data.forEach(({ listId, name }) => foldersList.push({ value: listId, label: name }))

  return foldersList
}

const getDataOptions = async ({ requestedData = [], params = {} }) => {
  const responsedData = {}

  for (const dataType of requestedData) {
    if (dataType === 'processesOptions') responsedData[dataType] = await processesOptions({ headerId: params.headerId, currentProcess: params.currentProcess })

    if (dataType === 'randomResponsesOptions') responsedData[dataType] = await randomResponsesOptions()

    if (dataType === 'operatorsOptions') responsedData[dataType] = await operatorsOptions({ delegations: params.delegations, brands: params.brands })

    if (dataType === 'vaOptions') responsedData[dataType] = await vaOptions()

    if (dataType === 'vaCategoriesOptions') responsedData[dataType] = await vaCategoriesOptions({ consoleId: params.consoleId })

    if (dataType === 'vaFaqsOptions') responsedData[dataType] = await vaFaqsOptions({ consoleId: params.consoleId, categoryName: params.categoryName })

    if (dataType === 'categoriesOptions') responsedData[dataType] = await categoriesOptions()

    if (dataType === 'managementListsOptions') responsedData[dataType] = await foldersOptions()

    if (dataType === 'foldersOptions') responsedData[dataType] = await foldersOptions()
  }

  return responsedData
}

export default getDataOptions
